"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewLineageButton = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelHelpers_1 = require("./LabelHelpers");
const VIEW_LINEAGE_BUTTON_TEST_ID = 'view_lineage_button';
function ViewLineageButton({ contentType }) {
    var _a, _b, _c;
    const { linksDisabled } = react_1.default.useContext(LabelHelpers_1.LabelButtonContext);
    const { content } = react_1.default.useContext(LabelHelpers_1.LabelsPopoverContext);
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const onLineageTab = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) === null || _b === void 0 ? void 0 : _b.includes('lineage')) !== null && _c !== void 0 ? _c : false;
    if (linksDisabled) {
        return null;
    }
    if ((content === null || content === void 0 ? void 0 : content.subjectArea) === undefined || content.contentId === undefined || content.contentId === '') {
        return null;
    }
    const lineagePath = (0, LabelHelpers_1.buildLineagePath)(siteUrls, content === null || content === void 0 ? void 0 : content.subjectArea, content.contentId);
    const showButton = !onLineageTab && lineagePath.length > 0;
    switch (contentType) {
        case 'Column':
        case 'column':
        case 'Field':
        case 'FlowColumnOutputField':
        case 'FlowFieldOutputField':
            return (showButton
                ? (react_1.default.createElement(widgets_1.TextLinkWidget, { href: linksDisabled ? '' : lineagePath, testId: VIEW_LINEAGE_BUTTON_TEST_ID, style: { float: 'right' }, target: '_self', kind: widgets_1.TextLinkKind.Standalone }, catalog_messages_1.Messages.Label_view_lineage_button()))
                : null);
        default:
            return null;
    }
}
exports.ViewLineageButton = ViewLineageButton;
//# sourceMappingURL=LabelLineageButton.js.map